import dagre from '@dagrejs/dagre';
import type { EntityNode, OwnershipEdge } from '../OrgDiagram/graph/types';

// Tax-chart nodes: 160×120 box (mirrors Figma 859:2495/2535/2572/2614).
// Locked dims so dagre lays out without a measure pass.
export const TAX_NODE_WIDTH = 160;
export const TAX_NODE_HEIGHT = 120;

// One gap for every rank pair, so every edge is drawn over the same vertical
// distance. Mirrors OrgDiagram/graph/layout.ts.
const RANKSEP = 112;

// Mirrors OrgDiagram/graph/layout.ts#layoutGraph but with TAX_NODE_*
// dimensions. Kept as a sibling (not a parameterised shared helper) per
// "don't touch existing org chart" — see TaxDiagram README.
export function layoutGraph(
  nodes: EntityNode[],
  edges: OwnershipEdge[],
): { nodes: EntityNode[]; edges: OwnershipEdge[] } {
  if (nodes.length === 0) return { nodes, edges };

  const g = new dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
  g.setGraph({
    rankdir: 'TB',
    ranker: 'tight-tree',
    nodesep: 64,
    ranksep: RANKSEP,
  });

  for (const n of nodes) {
    g.setNode(n.id, { width: TAX_NODE_WIDTH, height: TAX_NODE_HEIGHT });
  }
  for (const e of edges) {
    g.setEdge(e.source, e.target);
  }

  dagre.layout(g);

  const positionedNodes = nodes.map((n) => {
    const { x, y } = g.node(n.id);
    return {
      ...n,
      position: {
        x: x - TAX_NODE_WIDTH / 2,
        y: y - TAX_NODE_HEIGHT / 2,
      },
      initialWidth: TAX_NODE_WIDTH,
      initialHeight: TAX_NODE_HEIGHT,
    };
  });

  return { nodes: positionedNodes, edges };
}
